SupportLiveVoucherStatusAndNotesPresentation =
	editable:
		status: "Can be edited until <span class='localtime'>{{editable_deadline}}</span>"
		notes: "You can edit this order until 11:59 p.m. on the day you purchased. However, it cannot be edited after you view or print your Groupon."
	not_editable:
		redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""
		expired:
			status: "Event has passed"
			notes: ""
		expired_unredeemed:
			status: "Event has passed"
			notes: ""
		expired_redeemed:
			status: "Event has passed"
			notes: ""
		redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""
		available:
			status: "Ready to print"
			notes: "To use your Groupon, click \"View Voucher\" and follow the steps under \"How to Use This\" on your Groupon. "

module.exports = SupportLiveVoucherStatusAndNotesPresentation
